export default {"src":"/_next/static/media/seasonal-interest.41189bda.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};